export const CodeTemplate = (data) => {
    return `<div class="preview--block code" id="code_${data.id}"></div>`;
};

export default CodeTemplate;
